// context/MenuContext.js
import React, { createContext, useContext, useState } from 'react';

export const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  // UI menu state only
  const [menuOpen, setMenuOpen] = useState(false);

  // Toggle the UI menu state
  const toggleMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  const value = {
    // UI menu state
    menuOpen,
    toggleMenu,
    setMenuOpen,
  };

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error('useMenuContext must be used within a MenuProvider');
  }
  return context;
};
